import { AvatarGroup as AntdAvatarGroup } from "@empglabs/backoffice-ui-kit"

function AvatarGroup(props) {
  return <AntdAvatarGroup {...props} />
}

export default AvatarGroup
//